import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import 'semantic-ui-css/semantic.min.css';
import { reducer as toastrReducer } from 'react-redux-toastr';
import loginReducer from '../Modules/Login/reducer';
import navigationReducer from '../Modules/Navigation/reducer';
import permissionsReducer from '../Modules/Permissions/reducer';
import ordersReducer from '../Modules/Orders/reducer';
import productDetailsReducer from '../Modules/ProductDetails/reducer';
import createProductReducer from '../Modules/CreateNewProduct/reducer';
import createVariantReducer from '../Modules/CreateNewVariant/reducer';
import createMVReducer from '../Modules/CreateNewManufacturerVariant/reducer';
import ordersDetailsReducer from '../Modules/OrdersDetails/reducer';
import paymentDetailsReducer from '../Modules/PaymentDetails/reducer';
// import futureOrdersReducer from '../Modules/FutureOrders/reducer';
import manufactureVariantReducer from '../Modules/ManufactureVariants/reducer';
import vmReducer from '../Modules/VMs/reducer';
import vmDetailsReducer from '../Modules/VMDetails/reducer';
import uploadCashbackReducer from '../Modules/UploadCashBackFile/UploadComponent/reducer';
import downloadReducer from '../Modules/DownloadCSV/reducer';
import userListReducer from '../Modules/UsersList/reducer';
import myOrganizationReducer from '../Modules/MyOrganization/reducer';

export default combineReducers({
  routing: routerReducer,
  toastr: toastrReducer,
  login: loginReducer,
  navigation: navigationReducer,
  permissions: permissionsReducer,
  orders: ordersReducer,
  productDetails: productDetailsReducer,
  createProduct: createProductReducer,
  createVariant: createVariantReducer,
  createMV: createMVReducer,
  orderDetails: ordersDetailsReducer,
  paymentDetails: paymentDetailsReducer,
  manufactureVariant: manufactureVariantReducer,
  vms: vmReducer,
  myOrganization: myOrganizationReducer,
  vmDetails: vmDetailsReducer,
  // futureOrders: futureOrdersReducer,
  uploadCashback: uploadCashbackReducer,
  downloadCSV: downloadReducer,
  userList: userListReducer
});


// WEBPACK FOOTER //
// ./src/reducers/index.js